import { createApp } from 'vue';
import { createGtag } from 'vue-gtag';
import { createI18n } from 'vue-i18n';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import config from '@/config';
import App from './App.vue';
import lang from './assets/i18n/lang.json';
import clickout from './directives/clickoutside';
import adminMiddleware from './helpers/admin';
import authMiddleware from './helpers/auth';
import mainUserMiddleware from './helpers/mainUser';
import router from './router';
import store from './store/index';
import Utils from './utils';

const app = createApp(App);
const gtag = createGtag({ tagId: import.meta.env.VITE_GTAG });
const utils = new Utils(app);

app.config.productionTip = false;

const i18n = createI18n({
  locale: 'fr',
  messages: lang,
});

app.directive('clickout', clickout);

app.use(authMiddleware, { store, router });
app.use(adminMiddleware, { store, router });
app.use(mainUserMiddleware, { store, router });
app.use(router);
app.use(store);
app.use(i18n);
app.use(VueReCaptcha, { siteKey: config.RECAPTCHA_SITE_KEY });

if (localStorage.getItem('KYCCookies')) app.use(gtag);
app.use(() => {
  Object.defineProperty(app.config.globalProperties, '$utils', { get: () => utils });
});

app.mount('#app');
